import countries from '@/core/country.json';

const countriesFrozen = Object.freeze(countries);
export const ADDRESS_FIELDS_UK = Object.freeze([
  {
    name: 'addressLines',
    value: '',
    label: 'Street Address',
    isInvalid: null,
    theType: 'text',
    validation: {
      errorMessage: 'Enter valid street address',
    },
  },
  {
    name: 'locality',
    value: '',
    label: 'City',
    isInvalid: null,
    theType: 'text',
    validation: {
      errorMessage: 'Enter valid city',
    },
  },
  {
    name: 'administrativeArea',
    value: '',
    label: 'State/County',
    isInvalid: null,
    theType: 'text',
    list: [
      {
        id: 1,
        code: 'ABC',
        state: 'Armagh',
      },
      {
        id: 2,
        code: 'ABN',
        state: 'Aberdeen',
      },
      {
        id: 3,
        code: 'ABNS',
        state: 'Aberdeenshire',
      },
      {
        id: 4,
        code: 'AGS',
        state: 'Angus',
      },
      {
        id: 5,
        code: 'ANG',
        state: 'Anglesey',
      },
      {
        id: 6,
        code: 'ANN',
        state: 'Antrim',
      },
      {
        id: 7,
        code: 'ARY',
        state: 'Argyll and Bute',
      },
      {
        id: 8,
        code: 'ARYE',
        state: 'East Ayrshire',
      },
      {
        id: 9,
        code: 'ARYN',
        state: 'North Ayrshire',
      },
      {
        id: 10,
        code: 'ARYS',
        state: 'South Ayrshire',
      },
      {
        id: 11,
        code: 'BAS',
        state: 'Bath and North East Somerset',
      },
      {
        id: 12,
        code: 'BBD',
        state: 'Blackburn with Darwen',
      },
      {
        id: 13,
        code: 'BEDS',
        state: 'Bedfordshire',
      },
      {
        id: 14,
        code: 'BERKS',
        state: 'Berkshire',
      },
      {
        id: 15,
        code: 'BGW',
        state: 'Blaenau Gwent',
      },
      {
        id: 16,
        code: 'BLA',
        state: 'Blaenau Gwent',
      },
      {
        id: 17,
        code: 'BMH',
        state: 'Bournemouth',
      },
      {
        id: 18,
        code: 'BNH',
        state: 'Brighton and Hove',
      },
      {
        id: 19,
        code: 'BOR',
        state: 'Scottish Borders',
      },
      {
        id: 20,
        code: 'BPL',
        state: 'Blackpool',
      },
      {
        id: 21,
        code: 'BRC',
        state: 'Bracknell Forest',
      },
      {
        id: 22,
        code: 'BRI',
        state: 'Bridgend',
      },
      {
        id: 23,
        code: 'BSTL',
        state: 'Bristol',
      },
      {
        id: 24,
        code: 'BUCKS',
        state: 'Buckinghamshire',
      },
      {
        id: 25,
        code: 'CAE',
        state: 'Caerphilly',
      },
      {
        id: 26,
        code: 'CAMBS',
        state: 'Cambridgeshire',
      },
      {
        id: 27,
        code: 'CARM',
        state: 'Carmarthenshire',
      },
      {
        id: 28,
        code: 'CBF',
        state: 'Central Bedfordshire',
      },
      {
        id: 29,
        code: 'CDF',
        state: 'Cardiff',
      },
      {
        id: 30,
        code: 'CDGN',
        state: 'Ceredigion',
      },
      {
        id: 31,
        code: 'CHE',
        state: 'Cheshire East',
      },
      {
        id: 32,
        code: 'CHW',
        state: 'Cheshire West and Chester',
      },
      {
        id: 33,
        code: 'CLACK',
        state: 'Clackmannanshire',
      },
      {
        id: 34,
        code: 'CMA',
        state: 'Cumbria',
      },
      {
        id: 35,
        code: 'CON',
        state: 'Conwy',
      },
      {
        id: 36,
        code: 'CORN',
        state: 'Cornwall',
      },
      {
        id: 37,
        code: 'DAL',
        state: 'Darlington',
      },
      {
        id: 38,
        code: 'DER',
        state: 'Derby',
      },
      {
        id: 39,
        code: 'DERBY',
        state: 'Derbyshire',
      },
      {
        id: 40,
        code: 'DGL',
        state: 'Dumfries and Galloway',
      },
      {
        id: 41,
        code: 'DHM',
        state: 'Durham',
      },
      {
        id: 42,
        code: 'DNBG',
        state: 'Denbighshire',
      },
      {
        id: 43,
        code: 'DOR',
        state: 'Dorset',
      },
      {
        id: 44,
        code: 'DOW',
        state: 'Down',
      },
      {
        id: 45,
        code: 'DUNBE',
        state: 'East Dunbartonshire',
      },
      {
        id: 46,
        code: 'DUND',
        state: 'Dundee',
      },
      {
        id: 47,
        code: 'DVN',
        state: 'Devon',
      },
      {
        id: 48,
        code: 'EDIN',
        state: 'Edinburgh',
      },
      {
        id: 49,
        code: 'ELS',
        state: 'Eilean Siar',
      },
      {
        id: 50,
        code: 'ERYS',
        state: 'East Riding of Yorkshire',
      },
      {
        id: 51,
        code: 'ESX',
        state: 'Essex',
      },
      {
        id: 52,
        code: 'FALK',
        state: 'Falkirk',
      },
      {
        id: 53,
        code: 'FFE',
        state: 'Fife',
      },
      {
        id: 54,
        code: 'FLINT',
        state: 'Flintshire',
      },
      {
        id: 55,
        code: 'FMO',
        state: 'Fermanagh',
      },
      {
        id: 56,
        code: 'GDD',
        state: 'Gwynedd',
      },
      {
        id: 57,
        code: 'GLAS',
        state: 'Glasgow',
      },
      {
        id: 58,
        code: 'GLOS',
        state: 'Gloucestershire',
      },
      {
        id: 59,
        code: 'HAL',
        state: 'Halton',
      },
      {
        id: 60,
        code: 'HANTS',
        state: 'Hampshire',
      },
      {
        id: 61,
        code: 'HERTS',
        state: 'Hertfordshire',
      },
      {
        id: 62,
        code: 'HLD',
        state: 'Highlands',
      },
      {
        id: 63,
        code: 'HPL',
        state: 'Hartlepool',
      },
      {
        id: 64,
        code: 'HWR',
        state: 'Herefordshire',
      },
      {
        id: 65,
        code: 'IOS',
        state: 'Isles of Scilly',
      },
      {
        id: 66,
        code: 'IOW',
        state: 'Isle of Wight',
      },
      {
        id: 67,
        code: 'IVER',
        state: 'Inverclyde',
      },
      {
        id: 68,
        code: 'KHL',
        state: 'Kingston upon Hull',
      },
      {
        id: 69,
        code: 'KNT',
        state: 'Kent',
      },
      {
        id: 70,
        code: 'LANCS',
        state: 'Lancashire',
      },
      {
        id: 71,
        code: 'LANN',
        state: 'North Lanarkshire',
      },
      {
        id: 72,
        code: 'LANS',
        state: 'South Lanarkshire',
      },
      {
        id: 73,
        code: 'LCE',
        state: 'Leicester',
      },
      {
        id: 74,
        code: 'LDN',
        state: 'Greater London',
      },
      {
        id: 75,
        code: 'LDY',
        state: 'Londonderry',
      },
      {
        id: 76,
        code: 'LEC',
        state: 'Leicestershire',
      },
      {
        id: 77,
        code: 'LINCS',
        state: 'Lincolnshire',
      },
      {
        id: 78,
        code: 'LOTE',
        state: 'East Lothian',
      },
      {
        id: 79,
        code: 'LUT',
        state: 'Luton',
      },
      {
        id: 80,
        code: 'MCH',
        state: 'Greater Manchester',
      },
      {
        id: 81,
        code: 'MDB',
        state: 'Middlesbrough',
      },
      {
        id: 82,
        code: 'MDW',
        state: 'Medway',
      },
      {
        id: 83,
        code: 'MERT',
        state: 'Merthyr Tydfil',
      },
      {
        id: 84,
        code: 'MIK',
        state: 'Milton Keynes',
      },
      {
        id: 85,
        code: 'MLOT',
        state: 'Midlothian',
      },
      {
        id: 86,
        code: 'MMOUTH',
        state: 'Monmouthshire',
      },
      {
        id: 87,
        code: 'MORAY',
        state: 'Moray',
      },
      {
        id: 88,
        code: 'MSY',
        state: 'Merseyside',
      },
      {
        id: 89,
        code: 'NEL',
        state: 'North East Lincolnshire',
      },
      {
        id: 90,
        code: 'NEWPT',
        state: 'Newport',
      },
      {
        id: 91,
        code: 'NGM',
        state: 'Nottingham',
      },
      {
        id: 92,
        code: 'NHM',
        state: 'Northamptonshire',
      },
      {
        id: 93,
        code: 'NLD',
        state: 'Northumberland',
      },
      {
        id: 94,
        code: 'NLN',
        state: 'North Lincolnshire',
      },
      {
        id: 95,
        code: 'NOR',
        state: 'Norfolk',
      },
      {
        id: 96,
        code: 'NPRTAL',
        state: 'Neath Port Talbot',
      },
      {
        id: 97,
        code: 'NSM',
        state: 'North Somerset',
      },
      {
        id: 98,
        code: 'NTT',
        state: 'Nottinghamshire',
      },
      {
        id: 99,
        code: 'OFE',
        state: 'Oxfordshire',
      },
      {
        id: 100,
        code: 'ORK',
        state: 'Orkney Islands',
      },
      {
        id: 101,
        code: 'PEM',
        state: 'Pembrokeshire',
      },
      {
        id: 102,
        code: 'PERTH',
        state: 'Perth and Kinross',
      },
      {
        id: 103,
        code: 'PLY',
        state: 'Plymouth',
      },
      {
        id: 104,
        code: 'POL',
        state: 'Poole',
      },
      {
        id: 105,
        code: 'POR',
        state: 'Portsmouth',
      },
      {
        id: 106,
        code: 'PTE',
        state: 'Peterborough',
      },
      {
        id: 107,
        code: 'PWS',
        state: 'Powys',
      },
      {
        id: 108,
        code: 'RCC',
        state: 'Redcar and Cleveland',
      },
      {
        id: 109,
        code: 'RDG',
        state: 'Reading',
      },
      {
        id: 110,
        code: 'REN',
        state: 'Renfrewshire',
      },
      {
        id: 111,
        code: 'RENE',
        state: 'East Renfrewshire',
      },
      {
        id: 112,
        code: 'RHON',
        state: 'Rhondda Cynon Taff',
      },
      {
        id: 113,
        code: 'RUT',
        state: 'Rutland',
      },
      {
        id: 114,
        code: 'SFD',
        state: 'Staffordshire',
      },
      {
        id: 115,
        code: 'SFK',
        state: 'Suffolk',
      },
      {
        id: 116,
        code: 'SGC',
        state: 'South Gloucestershire',
      },
      {
        id: 117,
        code: 'SHET',
        state: 'Shetland Islands',
      },
      {
        id: 118,
        code: 'SLG',
        state: 'Slough',
      },
      {
        id: 119,
        code: 'SOM',
        state: 'Somerset',
      },
      {
        id: 120,
        code: 'SOS',
        state: 'Southend-on-Sea',
      },
      {
        id: 121,
        code: 'SPE',
        state: 'Shropshire',
      },
      {
        id: 122,
        code: 'SRY',
        state: 'Surrey',
      },
      {
        id: 123,
        code: 'STE',
        state: 'Stoke-on-Trent',
      },
      {
        id: 124,
        code: 'STH',
        state: 'Southampton',
      },
      {
        id: 125,
        code: 'STIR',
        state: 'Stirling',
      },
      {
        id: 126,
        code: 'STT',
        state: 'Stockton-on-Tees',
      },
      {
        id: 127,
        code: 'SWAN',
        state: 'Swansea',
      },
      {
        id: 128,
        code: 'SWD',
        state: 'Swindon',
      },
      {
        id: 129,
        code: 'SXE',
        state: 'East Sussex',
      },
      {
        id: 130,
        code: 'SXW',
        state: 'West Sussex',
      },
      {
        id: 131,
        code: 'TFW',
        state: 'Telford and Wrekin',
      },
      {
        id: 132,
        code: 'THR',
        state: 'Thurrock',
      },
      {
        id: 133,
        code: 'TOB',
        state: 'Torbay',
      },
      {
        id: 134,
        code: 'TORF',
        state: 'Torfaen',
      },
      {
        id: 135,
        code: 'TWR',
        state: 'Tyne and Wear',
      },
      {
        id: 136,
        code: 'TYR',
        state: 'Tyrone',
      },
      {
        id: 137,
        code: 'VGLAM',
        state: 'Vale of Glamorgan',
      },
      {
        id: 138,
        code: 'WARKS',
        state: 'Warwickshire',
      },
      {
        id: 139,
        code: 'WBK',
        state: 'West Berkshire',
      },
      {
        id: 140,
        code: 'WDUN',
        state: 'West Dunbartonshire',
      },
      {
        id: 141,
        code: 'WIL',
        state: 'Western Isles',
      },
      {
        id: 142,
        code: 'WLOT',
        state: 'West Lothian',
      },
      {
        id: 143,
        code: 'WLT',
        state: 'Wiltshire',
      },
      {
        id: 144,
        code: 'WMD',
        state: 'West Midlands',
      },
      {
        id: 145,
        code: 'WNM',
        state: 'Windsor and Maidenhead',
      },
      {
        id: 146,
        code: 'WOK',
        state: 'Wokingham',
      },
      {
        id: 147,
        code: 'WORCS',
        state: 'Worcestershire',
      },
      {
        id: 148,
        code: 'WRT',
        state: 'Warrington',
      },
      {
        id: 149,
        code: 'WRX',
        state: 'Wrexham',
      },
      {
        id: 150,
        code: 'YOK',
        state: 'York',
      },
      {
        id: 151,
        code: 'YSN',
        state: 'North Yorkshire',
      },
      {
        id: 152,
        code: 'YSS',
        state: 'South Yorkshire',
      },
      {
        id: 153,
        code: 'YSW',
        state: 'West Yorkshire',
      },
    ],
    validation: {
      errorMessage: 'Select a state',
    },
  },
  {
    name: 'regionCode',
    value: 'United Kingdom (Great Britain)',
    code: 'GB',
    label: 'Country',
    isInvalid: false,
    list: countriesFrozen,
    theType: 'text',
    validation: {
      errorMessage: 'Select a country',
    },
  },
  {
    name: 'postalCode',
    value: '',
    isInvalid: null,
    label: 'Postcode',
    theType: 'text',
    validation: {
      errorMessage: 'Enter valid postcode',
    },
  },
]);
